module.exports = __webpack_public_path__ + "media/images/common/mail-d2eeb5165e81ddc6e5569100b18b4699.gif";